import GraphWidgets from '../components/homepage/GraphWidgets'

export default function Index() {
    return (
        <div className={'page-container'}>
            <GraphWidgets />
        </div>
    )
}
